import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-bachelor-of-commerce-degree-a-comprehensive-guide',
  templateUrl: './bachelor-of-commerce-degree-a-comprehensive-guide.component.html',
  styleUrls: ['./bachelor-of-commerce-degree-a-comprehensive-guide.component.scss']
})
export class BachelorOfCommerceDegreeAComprehensiveGuideComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  ngOnInit(): void {
  }

}
